import {PaginationComponent} from "./pagination.component";

export const Pagination = PaginationComponent;
